<template>
    <page>
        <module enable-flex>
            <m-search @search="search">
                <m-search-item label="页面标题">
                    <c-input name="title"></c-input>
                </m-search-item>
            </m-search>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        label="页面标题"
                        name="title"
                        width="320"
                        fixed="left"
                ></c-table-column>

                <c-table-column label="更新时间" name="update_date" width="160"></c-table-column>

                <c-table-column type="button" label="操作" width="100">
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_system_single_page_edit')" icon="tf-edit" @click="editArticle(data)">编辑</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
export default {
    mounted() {
        this.search({});
    },

    methods: {
        editArticle(data) {
            this.globalDialog('systemArticleEdit', {
                props: {type: 'single-page', id: data ? data.id : ''},
            }, () => this.$refs.list.update());
        },

        search(data) {
            this.$refs.list.load({
                url: '/article/list',
                data: Object.assign({}, data || {}, {article_type: 0}),
            });
        },
    },
};
</script>
